import React from 'react';
import palette from '../../palette';
import { useDesignSystemTheme } from '../../providers/DesignSystemThemeProvider';
import { DEFAULT_ICON_SIZE } from './Icon.constants';
import { IconRoot } from './Icon.styles';
import { getIconType } from './Icon.utils';
const defaultProps = {
  size: DEFAULT_ICON_SIZE,
  title: null,
  primaryColor: undefined
};
export const Icon = _ref => {
  let {
    __setDangerouslyInnerClassName,
    iconComponent,
    size = DEFAULT_ICON_SIZE,
    primaryColor,
    ...restProps
  } = _ref;
  const theme = useDesignSystemTheme();
  const primaryColorResolved = primaryColor ?? theme.Icon.defaultVariant;
  const dangerouslySetClassName = __setDangerouslyInnerClassName?.hasOwnProperty('className') && __setDangerouslyInnerClassName.className.length > 0 ? __setDangerouslyInnerClassName.className : undefined;
  const iconColor = theme.Icon.iconColorToPaletteColor[primaryColorResolved] || palette[primaryColorResolved];
  const iconType = getIconType(iconComponent.__name);
  return React.createElement(IconRoot, {
    as: iconComponent,
    "data-test-id": restProps['data-test-id'] ?? iconComponent.__name,
    size: size,
    iconColor: iconColor,
    iconType: iconType,
    "aria-hidden": !restProps.title,
    "aria-label": restProps.title ?? iconComponent.__name,
    primaryColor: iconColor,
    colorMapping: theme.colorMapping,
    role: "img",
    className: dangerouslySetClassName,
    "data-component": "Icon"
  });
};